<template>
  <div>
    <set-nav-bar :typeId="code" :step="step"></set-nav-bar>
    <!-- 申请人类型选择浮层 -->
    <div class="upload_overlay" v-show="isShowOverlay">
      <div class="upload_desc">选择申请人的类型</div>
      <div class="upload_type">
        <div
          class="upload_type_item"
          @click="selectType(item)"
          v-for="(item, index) in htas"
          :key="'type' + index"
        >
          <div class="type_item_c1">{{ item.idTypeDispName }}</div>
          <!-- <div class="type_item_c2">{{ item.desc }}</div> -->
        </div>
      </div>
    </div>
    <div class="upload-page" v-if="isShowPage">
      <div class="type-view">
        <a
          class="weui-cell weui-cell_access weui-cell_example"
          href="javascript:;"
          v-if="isShowType"
          @click="showType"
        >
          <div class="weui-cell__hd icon-select">
            <img
              src="../assets/selected.svg"
              alt
              style="width: 20px; margin-right: 16px; display: block"
            />
          </div>
          <div class="weui-cell__bd">
            <p>{{ typeName }}</p>
          </div>
          <div class="weui-cell__ft">切换类型</div>
        </a>
        <!-- <a
          class="weui-cell weui-cell_access weui-cell_example"
          href="javascript:;"
          @click="typeSelect"
        >
          <div class="weui-cell__bd">
            <p>证件类型</p>
          </div>
          <div class="weui-cell__ft">{{ idType }}</div>
        </a> -->
      </div>
      <div class="uploadtip">
        <span class="Sensitiveinformation" @click="SensitiveInfo"
          >敏感信息用途</span
        >
        <div v-html="html" class="upload-tips"></div>

        <!-- <van-button
        type="primary"
        size="large"
        class="powerOfAttorney"
        safe-area-inset-bottom
        @click="powerOfAttorneyClick"
        color="#1aad19"
        >点击查看/下载委托书模板</van-button> -->
        <span
          class="powerOfAttorney"
          v-if="isTrustInstrumentButton"
          @click="powerOfAttorneyClick(true)"
          >点击查看/下载委托书模板</span
        >
      </div>
      <div class="wyf-ui">
        <div
          class="wyfui-col-33"
          v-for="(item, index) in verifyImages"
          :key="'upload' + index"
          @click="chooseImage(index)"
        >
          <div>
            <img
              class="wyfui-image"
              :id="'image' + index"
              :src="item.verfiySampleImageUrl"
            />
            <div class="item-idcardt">
              <div class="text-idcard">{{ item.displayName }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="weui-gallery" style="display: block;">
			        <span class="weui-gallery__img" style="background-image: url(https://github.com/Tencent/weui/blob/master/dist/example/images/pic_article.png);"></span>
			        <div class="weui-gallery__opr">
			            <a href="javascript:" class="weui-gallery__del">
			                <i class="weui-icon-delete weui-icon_gallery-delete"></i>
			            </a>
			        </div>
      </div>-->
      <div id="uploader-demo" style="margin-top: 15px; display: none">
        <div id="filePicker"></div>
        <input
          type="file"
          class="fileInput"
          hidden
          id="fileInputId"
          accept="image/*"
          mutiple="mutiple"
          capture="camera"
        />
      </div>
      <div class="line"></div>
      <div class="upload-input">
        <van-field
          v-model="name"
          label="患者姓名"
          placeholder="请输入患者姓名"
        />
        <van-field
          v-model="cardId"
          label="证件号码"
          placeholder="请输入证件号码"
          @input="inputCardNo"
          :right-icon="rightIcon"
          @click-right-icon="showErrorMsg"
          color="red"
        />
      </div>
    </div>
    <van-button
      type="primary"
      size="large"
      class="btn-next"
      safe-area-inset-bottom
      @click="next"
      color="#1aad19"
      >下一步</van-button
    >

    <div
      class="trustInstrumentDiv"
      id="overlayId"
      v-if="isTrustInstrumentReveal"
    >
      <div class="trustInstrumentImg">
        <img :src="trustInstrumentUrl" />
      </div>
      <van-button
        type="primary"
        color="#1aad19"
        @click="powerOfAttorneyClick()"
        class="btn_confirm"
        block
        >关闭
      </van-button>
    </div>
  </div>
</template>

<script>
import SetNavBar from "../components/SetNavBar.vue";
import $ from "jquery";
import EXIF from "exif-js";
import WebUploader from "webuploader";

import "../styles/webuploader.css";
import Vue from "vue";
import { ImagePreview } from "vant";
Vue.use(ImagePreview);
import { Cell, CellGroup, Uploader, Field, Notify, Toast, Dialog } from "vant";
Vue.prototype.EXIF = EXIF;
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Field);
Vue.use(Notify);
Vue.use(Toast);
Vue.use(Dialog);
let hosIdType;
let servicePathArr = [];
let idCardOcrTypeList = [];
let verifyRule1 = "";
let imageType = "";
let hosItem = new Object();
let cardType = "";
let vLibId = "";
let uploadFlag = 0;
let wxId;
let hosMinAge = "";

// let uploader;
export default {
  name: "upload",
  data() {
    return {
      code: "",
      step: 2,
      html: "",
      cardId: "",
      name: "",
      idType: "",
      isShowOverlay: false,
      typeName: "",
      isShowType: false,
      fileList: [
        {
          url: "https://img.yzcdn.cn/vant/leaf.jpg",
        },
      ],
      isShowPage: false,
      verifyImages: [],
      htas: [],
      previewIndex: 0,
      avatar: require("../assets/add.svg"),
      imageUrl: "",
      rightIcon: "",
      uploadState: false,
      // fileCount:0,
      fileSize: 0,
      idPurposes: "",
      // 埋点
      mdreferrer: "",
      mdreferrer_title: "",
      // qrView:''
      isFirstDay: false,
      // 是否有委托书
      isTrustInstrumentButton: false,
      isTrustInstrumentReveal: false,
      trustInstrumentUrl: "",
    };
  },
  components: {
    SetNavBar,
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    console.log("thisInBeforeRouteEnter", this);
    next((vm) => {
      console.log("thisInBeforeRouteEnterNext", this);
      console.log("vm", vm);
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
      // console.log(vm.getMsg());
      vm.mdreferrer = from.path;
      if (from.name == "" || from.name == null || from.name == undefined) {
        vm.mdreferrer_title = "无上一页";
      } else {
        vm.mdreferrer_title = from.name;
      }
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
    });
  },
  created() {
    console.log("created");
    uploadFlag = 0;
    let hositem = localStorage.getItem("HosItem");

    hosItem = JSON.parse(hositem);
    idCardOcrTypeList = hosItem.selectHbsType.hosInfo.idCardOcrTypeList;
    this.code = hosItem.code;
    let bId = hosItem.selectHbsType.types[0].bId;
    hosMinAge = hosItem.selectHbsType.hosInfo.hosMinAge;
    servicePathArr.splice(0, servicePathArr.length);
    wxId = localStorage.getItem("wxId");
    if (wxId == 13 || wxId == 45) {
      let params = {
        hosId: hosItem.hosId,
        wxId: wxId,
        bId: bId,
      };
      this.getTypeAttrs(params);
    } else {
      let params = {
        hosId: hosItem.hosId,
        wxId: wxId,
      };
      this.getTypeAttrs(params);
    }
  },
  mounted() {
    console.log("mounted");
    var everypage = JSON.parse(localStorage.getItem("everypage"));
    var zhaopianshangchuan = everypage.zhaopianshangchuan + 1;
    everypage.zhaopianshangchuan = zhaopianshangchuan;
    if (zhaopianshangchuan == 1) {
      this.isFirstDay = true;
    } else {
      this.isFirstDay = false;
    }
    localStorage.setItem("everypage", JSON.stringify(everypage));

    console.log(this, "这是mounted");
    var mdreferrer_title = localStorage.getItem("title");
    if (
      mdreferrer_title == "" ||
      mdreferrer_title == undefined ||
      mdreferrer_title == null
    ) {
      // mdreferrer = '没有上一页'
      mdreferrer_title = "没有上一页";
    }
    var title = this.$route.name;
    localStorage.setItem("mdreferrer_title", mdreferrer_title);
    localStorage.setItem("title", title);
    var url = this.$route.path;
    var url_path = this.$route.path;
    var is_first_Day = this.isFirstDay;
    var preview = "MPViewScreen";
    // var mdreferrer = this.mdreferrer;
    // var mdreferrer_title = this.mdreferrer_title;
    this.$util.BuriedPoint(
      title,
      url,
      url_path,
      is_first_Day,
      preview,
      mdreferrer_title
    );
  },
  beforeCreate() {
    console.log("beforeCreate");
  },
  beforeMount() {
    console.log("beforeMount");
  },
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  updated() {
    console.log("updated");
  },
  destroyed() {
    console.log("destroyed");
  },
  methods: {
    SensitiveInfo() {
      var idPurposes = this.idPurposes;
      Dialog.alert({
        title: "个人敏感信息的用途",
        message: idPurposes,
        confirmButtonText: "我已知晓",
      });
    },

    powerOfAttorneyInit() {
      console.log("this.verifyImages==> ", this.verifyImages);
      // 循环查询是否有委托书类型，有则显示按钮
      for (var i in this.verifyImages) {
        let type = this.verifyImages[i].type;
        // 正式环境要换成 TRUST_INSTRUMENT
        if (type == "TRUST_INSTRUMENT") {
          console.log("==> 检索到有委托书验证");
          this.isTrustInstrumentButton = true;
          this.trustInstrumentUrl = this.verifyImages[i].verfiySampleImageUrl;
          break;
        }
      }
    },

    powerOfAttorneyClick(flag) {
      this.isTrustInstrumentReveal = flag;
    },

    getApplyLog(params) {
      this.$server.getApplyLog(params).then((res) => {
        if (res.result == 1) {
          console.log("获取log成功____________________________");
        }
      });
    },
    showErrorMsg() {
      Notify({
        type: "warning",
        message: "请输入正确的证件号码",
      });
    },
    chooseImage(index) {
      if (this.uploadState == true) {
        return;
      }
      let that = this;
      console.log(index);
      this.previewIndex = index;

      let baseImageUrl = this.verifyImages[index].verfiySampleImageUrl;

      var imageId = "image" + index;
      imageType = hosIdType.verifyImages[index].type;
      let src = $("#" + imageId)[0].src;
      console.log(src,baseImageUrl)
      if (src == baseImageUrl) {
        // 添加相机，并主动响应input事件
        $("#fileInputId").trigger("click");
      } else {
        var gallery = that.$weui.gallery(src, {
          className: "custom-classname",
          onDelete: function () {
            // if(confirm('确定删除该图片？')){ console.log('删除'); }
            that.$weui.dialog({
              title: "确认",
              content: "是否要删除这张照片",
              className: "custom-classname",
              buttons: [
                {
                  label: "取消",
                  type: "default",
                  onClick: function () {
                    gallery.hide(function () {
                      console.log("`gallery` has been hidden");
                    });
                  },
                },
                {
                  label: "确定",
                  type: "primary",
                  onClick: function () {
                    gallery.hide(function () {
                      var baseUrl =
                        hosIdType.verifyImages[index].verfiySampleImageUrl;
                      $("#" + imageId).attr("src", baseUrl);
                      updateServicePathArr(index);
                    });
                  },
                },
              ],
            });
          },
        });
      }
    },

    // typeSelect() {
    //   var that = this;
    //   console.log(this.idTypes);
    //   let arr = [];
    //   let index;
    //   for (let i in this.idTypes) {
    //     let obj = new Object();
    //     obj.label = this.idTypes[i].idTypeDispName;
    //     obj.value = i;
    //     arr.push(obj);
    //     if (obj.label == this.idType) {
    //       index = i;
    //     }
    //   }
    //   this.$weui.picker(arr, {
    //     defaultValue: [index],
    //     className: "custom-classname",
    //     onChange: function (result) {
    //       console.log(result);
    //     },
    //     onConfirm: function (result) {
    //       console.log("confirm");
    //       console.log(result);
    //       that.idType = result[0].label;
    //       let i = parseInt(result[0].value);
    //       if (i != index) {
    //         that.name = "";
    //         that.cardId = "";
    //         let selectIdType = that.idTypes[i];
    //         let typeId = selectIdType.hosTypeId;
    //         cardType = selectIdType.idTypeName;
    //         // this.idType = selectIdType.idTypeDispName;
    //         var params = {
    //           hosId: hosItem.hosId,
    //           typeId: typeId,
    //         };
    //         that.getIdTypes(params);
    //       }
    //     },
    //     id: new Date(),
    //     title: "证件类型",
    //   });
    // },
    getTypeAttrs(params) {
      this.$server.getTypeAttrs(params).then((res) => {
        if (res.result == 1) {
          console.log(res, "00000003030303030");
          this.htas = res.hospitalIdTypes;
          if (this.htas == null) {
            this.isShowOverlay = false;
            this.isShowPage = true;
            // this.idType = res.hospitalIdTypes[0].idTypeDispName;
            // this.idTypes = res.hospitalIdTypes;
            // let selectIdType = this.idTypes[0];
            let typeId = this.htas.hosTypeId;
            cardType = this.htas.idTypeName;
            // this.idType = selectIdType.idTypeDispName;
            let paramsObj = {
              hosId: params.hosId,
              typeId: typeId,
            };
            this.getIdTypes(paramsObj);
          } else {
            if (this.htas.length == 1) {
              this.isShowOverlay = false;
              this.isShowPage = true;
            }
            this.isShowOverlay = true;
            this.isShowPage = false;
          }
        }
      });
    },
    getIdTypes(params) {
      this.$server.getIdTypes(params).then((res) => {
        if (res.result == 1) {
          console.log(res);
          hosIdType = res.idType;
          verifyRule1 = hosIdType.verifyRule1;
          this.html = hosIdType.desc;
          this.idPurposes = res.idType.idPurposes;
          this.verifyImages = hosIdType.verifyImages;
          if (uploadFlag == 0) {
            this.handleFile();
            uploadFlag = 1;
          }
          this.SensitiveInfo();
          this.powerOfAttorneyInit();
        }
      });
    },
    /**
     * 选择申请类型
     */
    selectType(item) {
      console.log(item);
      this.typeName = item.idTypeDispName;
      this.isShowType = true;
      // this.idTypes = item.hospitalIdTypes;
      // let selectIdType = this.idTypes[0];

      let typeId = item.hosTypeId;
      cardType = item.idTypeName;
      // this.idType = selectIdType.idTypeDispName;
      var params = {
        hosId: hosItem.hosId,
        typeId: typeId,
      };
      this.getIdTypes(params);
      this.isShowOverlay = false;
      this.isShowPage = true;
      uploadFlag = 0;
    },
    showType() {
      this.isShowOverlay = true;
      this.isShowPage = false;
      this.name = "";
      this.cardId = "";
      this.rightIcon = "";
    },
    createImageObj(uploaderNum, serverId) {
      updateServicePathArr(uploaderNum);
      /**
       *  requestImageIndex: 第几张: 从0 开始
       *  imageBelong：图片归属，0：患者，1：代办人
       *  imageType： 图片类型:
       * 	imageUrl：图片file名
       *  imageDesc：图片mediaID
       *  imageStatus: 0,默认微信拉取（wx.jssdk使用）， 2：直接上传本地路径（url为本地服务器）
       **/

      var requestImageIndex;
      var imageDesc = "image";
      var imageBelong = 0;
      var imageUrl;
      var imageStatus = 2;

      requestImageIndex = uploaderNum;
      imageType =
        hosIdType.verifyImages.length > 0
          ? hosIdType.verifyImages[uploaderNum].type
          : "0";
      imageUrl = serverId;

      var imageObj = {
        requestImageIndex: requestImageIndex,
        imageBelong: imageBelong,
        imageType: imageType,
        imageUrl: imageUrl,
        imageDesc: imageDesc,
        imageStatus: imageStatus,
      };
      console.log(checkServicePathArr(requestImageIndex, servicePathArr));
      if (checkServicePathArr(requestImageIndex, servicePathArr)) {
        servicePathArr.splice(requestImageIndex, 1, imageObj);
      } else {
        servicePathArr.push(imageObj);
      }
    },

    /**
     * 验证证件号码
     */
    isRegValid(e) {
      this.rightIcon = "";
      if (verifyRule1 == "" || verifyRule1 == null) {
        return;
      }
      let regName = new RegExp(verifyRule1);

      if (regName.test(e)) {
        if (
          hosMinAge != null &&
          (cardType == "ID_TRAUMA_CARD" || cardType == "ID_TYPE_ID_CARD")
        ) {
          if (this.$util.getIdCardInfo(e).isTrue == false) {
            // console.log('false');
            this.rightIcon = "info-o";
          } else {
            this.rightIcon = "";
            // if(cardType == "ID_TRAUMA_CARD" || cardType == "ID_TYPE_ID_CARD") {
            // if (
            //   hosMinAge != null
            // ) {
            if (this.$util.extract(this.cardId, hosMinAge) == false) {
              console.log("999");
              // that.$util.extract(that.cardId,() => {
              Dialog.alert({
                title: "注意事项",
                message:
                  hosMinAge +
                  "岁以下患者单独申请，请更换未成年人代办类型进行申请办理。",
                confirmButtonText: "我已知晓",
              });
              this.showType(this);
              this.name = "";
              this.cardId = "";
              // })
            }
            // }
            // }
          }
        }
        else if (cardType == "ID_TYPE_ID_CARD") {
          if (this.$util.getIdCardInfo(e).isTrue == false) {
            // console.log('false');
            this.rightIcon = "info-o";
          } else {
            this.rightIcon = "";
          }
        }
        this.rightIcon = "";
      } else {
        this.rightIcon = "info-o";
      }
      return true;
    },
    /**
     * 证件号码输入监听
     */
    inputCardNo(e) {
      console.log(e);
      this.isRegValid(e);
    },
    next() {
      if (servicePathArr.length < hosIdType.verifyImages.length) {
        Notify({
          type: "warning",
          message: "请上传证件照片",
        });
        return;
      }
      if (this.$util.isNullString(this.name)) {
        Notify({
          type: "warning",
          message: "患者姓名不能为空",
        });
        return;
      }
      if (this.$util.isNullString(this.cardId)) {
        Notify({
          type: "warning",
          message: "证件号码不能为空",
        });
        return;
      }
      if (this.rightIcon != "") {
        Notify({
          type: "warning",
          message: "请输入正确的证件号码",
        });
        return;
      }
      console.log(servicePathArr);
      // console.log(hosItem)
      console.log(cardType, "这是cardType");
      hosItem.servicePathArr = servicePathArr;
      hosItem.patientName = this.name;
      hosItem.patientCardId = this.cardId;
      hosItem.patientCardType = cardType;
      hosItem.vLibId = vLibId;
      localStorage.setItem("HosItem", JSON.stringify(hosItem));
      let logparams = {
        userId: localStorage.getItem("userId"),
        phoneV: localStorage.getItem("os"),
        wxV: localStorage.getItem("version"),
        wxId: localStorage.getItem("wxId"),
        pId: 2,
        type: localStorage.getItem("selectTypeLog"),

        // hosId: hosId,
        // bType: selectHbsType.type,
      };
      this.getApplyLog(logparams);
      this.$router.push({
        name: "info",
        params: {
          patientName: this.name,
          idCardNo: this.cardId,
        },
      });
      // this.$router.push("/info/" + this.name + "/" + this.cardId);
    },

    handleFile() {
      console.log("handleFile");

      let token = localStorage.getItem("token");
      let that = this;
      let loading;
      let userId = localStorage.getItem("userId");
      var params = "userId=" + userId + "&token=" + token;

      $("#fileInputId").on("change", function () {
        // 初始化Web Uploader
        var uploader = WebUploader.create({
          // 选完文件后，是否自动上传。
          auto: true,

          // swf文件路径
          swf: "../utils/Uploader.swf",

          // 文件接收服务端。
          server: that.GLOBAL.BASE_URL + "v1/uploadImage?" + params,

          // 选择文件的按钮。可选。
          // 内部根据当前运行是创建，可能是input元素，也可能是flash.
          //                        pick: {
          //                            id: "#filePicker",
          //                            multiple: false
          //                        },

          // 可重复上传
          duplicate: true,

          // 只允许选择图片文件
          accept: {
            title: "Images",
            extensions: "gif,jpg,jpeg,bmp,png",
            mimeTypes: "image/*",
          },
          thumb: {
            width: 1,
            height: 1,

            // 图片质量，只有type为`image/jpeg`的时候才有效。
            quality: 70,

            // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
            allowMagnify: false,

            // 是否允许裁剪。
            crop: false,

            // 为空的话则保留原有图片格式。
            // 否则强制转换成指定的类型。
            // type: 'image/jpeg'
          },

          // 配置压缩的图片
          compress: {
            width: 1200,
            height: 1200,

            // 图片质量，只有type为`image/jpeg`的时候才有效。
            quality: 90,

            // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
            allowMagnify: false,

            // 是否允许裁剪。
            crop: false,

            // 是否保留头部meta信息。
            preserveHeaders: true,

            // 如果发现压缩后文件大小比原来还大，则使用原来图片
            // 此属性可能会影响图片自动纠正功能
            noCompressIfLarger: false,

            // 单位字节，如果图片大小小于此值，不会采用压缩。
            compressSize: 0,
          },
        });

        var file = this.files[0];

        var fileName = file.name;
        var size = file.size;
        var type = file.type;
        var newFile = null;
        console.log(fileName, size, type);

        var Orientation = 0;

        //图片方向角
        var rFilter =
          /^(image\/jpeg|image\/png|image\/jpg|image\/gif|image\/jpe)$/i; // 检查图片格式
        if (rFilter.test(file.type) && file !== undefined) {
          console.log("旋转开始");
          EXIF.getData(file, function () {
            Orientation = EXIF.getTag(this, "Orientation");
            if (file && Orientation > 1) {
              //获取照片方向角属性，用户旋转控制
              console.log(Orientation);
              var oReader = new FileReader();
              oReader.readAsDataURL(file);

              oReader.onload = function (e) {
                var image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                  var expectWidth = this.naturalWidth;
                  var expectHeight = this.naturalHeight;

                  var canvas = document.createElement("canvas");
                  var ctx = canvas.getContext("2d");
                  canvas.width = expectWidth;
                  canvas.height = expectHeight;
                  ctx.drawImage(this, 0, 0, expectWidth, expectHeight);
                  var base64 = null;
                  //修复ios
                  if (navigator.userAgent.match(/iphone/i)) {
                    console.log("iphone");
                    if (Orientation != "" && Orientation != 1) {
                      console.log(isMustRotateImg() > 0);
                      if (isMustRotateImg() > 0) {
                        switch (Orientation) {
                          case 6:
                            rotateImg(this, "left", canvas);
                            console.log("为666666a");
                            break;
                          case 8:
                            rotateImg(this, "right", canvas);
                            break;
                          case 3:
                            rotateImg(this, "right", canvas); //转两次
                            rotateImg(this, "right", canvas);
                            break;
                        }
                      }
                    }
                    base64 = canvas.toDataURL(file.type, 1);
                  } else if (navigator.userAgent.match(/Android/i)) {
                    base64 = canvas.toDataURL(file.type, 1);
                    // 修复android
                    //  var encoder = new JPEGEncoder();
                    //  base64 = encoder.encode(ctx.getImageData(0, 0, expectWidth, expectHeight), 80);
                  } else {
                    console.log("!!!!!!!!!!!!!!!!!!!!!");
                    if (Orientation != "" && Orientation != 1) {
                      switch (Orientation) {
                        case 6:
                          rotateImg(this, "left", canvas);
                          break;
                        case 8:
                          rotateImg(this, "right", canvas);
                          break;
                        case 3:
                          rotateImg(this, "right", canvas); //转两次
                          rotateImg(this, "right", canvas);
                          break;
                      }
                    }
                    base64 = canvas.toDataURL(file.type, 1);
                  }
                  var baseFile = dataURLtoFile(base64, fileName);
                  newFile = baseFile;
                  console.log(newFile.size);
                  uploader.addFile(newFile);
                };
              };
            } else {
              uploader.addFile(file);
            }
          });
        } else {
          uploader.addFile(file);
        }

        function isMustRotateImg() {
          console.log(idCardOcrTypeList, imageType);
          if (idCardOcrTypeList.indexOf(imageType) > -1) {
            console.log(imageType, "需要旋转");
            return 1;
          }
          return 0;
        }

        function dataURLtoFile(dataurl, filename) {
          //将base64转换为文件
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, {
            type: mime,
          });
        }

        function rotateImg(img, direction, canvas) {
          //alert(img);
          //最小与最大旋转方向，图片旋转4次后回到原方向
          var min_step = 0;
          var max_step = 3;
          //var img = document.getElementById(pid);
          if (img == null) return;
          //img的高度和宽度不能在img元素隐藏后获取，否则会出错
          var height = img.height;
          var width = img.width;
          //var step = img.getAttribute('step');
          var step = 2;
          if (step == null) {
            step = min_step;
          }
          if (direction == "right") {
            step++;
            //旋转到原位置，即超过最大值
            step > max_step && (step = min_step);
          } else {
            step--;
            step < min_step && (step = max_step);
          }
          //旋转角度以弧度值为参数
          var degree = (step * 90 * Math.PI) / 180;
          var ctx = canvas.getContext("2d");
          switch (step) {
            case 0:
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(img, 0, 0);
              break;
            case 1:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(degree);
              ctx.drawImage(img, 0, -height);
              break;
            case 2:
              canvas.width = width;
              canvas.height = height;
              ctx.rotate(degree);
              ctx.drawImage(img, -width, -height);
              break;
            case 3:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(degree);
              ctx.drawImage(img, -width, 0);
              break;
          }
        }

        // 当有文件添加进来的时候
        uploader.on("fileQueued", function (file) {
          console.log(file);
          // that.imageArr =
        });
        // 文件发送前，是否附加参数。
        uploader.on("uploadBeforeSend", function (obj, data) {
          data.hosId = hosItem.hosId;
          data.type = 1;
          data.wxId = localStorage.getItem("wxId");
          data.imageType = imageType;
          that.uploadState = true;
          console.log("uploadBeforeSend");
          loading = that.$weui.loading("上传中...", {
            className: "custom-classname",
          });
        });

        // // 文件上传过程中创建进度条实时显示。
        // uploader.on('uploadProgress', function(file, percentage) {
        // 	var $li = $('#' + file.id),
        // 		$percent = $li.find('.progress span');

        // 	// 避免重复创建
        // 	if (!$percent.length) {
        // 		$percent = $('<p class="progress"><span></span></p>')
        // 			.appendTo($li)
        // 			.find('span');
        // 	}

        // 	$percent.css('width', percentage * 100 + '%');
        // });

        // 文件上传成功，给item添加成功class, 用样式标记上传成功。
        uploader.on("uploadSuccess", function (file, response) {
          that.uploadState = false;
          console.log(response);
          loading.hide();
          if (response.result >= 2000) {
            Dialog({ message: response.msg });

            return;
          }
          uploader.makeThumb(
            file,
            function (error, src) {
              that.imageUrl = src;
              if (error) {
                // $img.replaceWith('<span>不能预览</span>');
                return;
              }
              var $imageId = "#image" + that.previewIndex;
              $($imageId).attr("src", src);
              $($imageId).addClass("wyfui-image");
              // var width = $($imageId).width();
              // var height = width * 0.8;
              // $($imageId).css('height', height);
            },
            1,
            1
          );
          vLibId = response.vLibId;
          that.createImageObj(that.previewIndex, response.files[0]);

          let name = response.name;
          let idNo = response.idNo;
          let CardFTip = response.msg;
          if (imageType == "ID_CARD_F") {
            that.name = name;
            that.cardId = idNo;

            if (
              hosMinAge != null &&
              (cardType == "ID_TRAUMA_CARD" || cardType == "ID_TYPE_ID_CARD")
            ) {
              console.log(
                that.$util.extract(that.cardId, hosMinAge),
                "这是函数结果2"
              );
              if (that.$util.extract(that.cardId, hosMinAge) == false) {
                console.log("999");
                // that.$util.extract(that.cardId,() => {
                Dialog.alert({
                  title: "注意事项",
                  message:
                    hosMinAge +
                    "岁以下患者单独申请，请更换未成年人代办类型进行申请办理。",
                  confirmButtonText: "我已知晓",
                });
                that.showType(that);
                that.name = "";
                that.cardId = "";
                // })
              }

              console.log("111");
            }
          } else {
            Notify({
              type: "warning",
              message: CardFTip,
            });
          }
        });
        // 文件上传失败，显示上传出错。
        uploader.on("uploadError", function (res) {
          console.log(res);
          that.uploadState = false;
          loading.hide();
          Notify({
            type: "warning",
            message: "上传失败,请稍后重试",
          });

          // var $li = $('#' + file.id),
          // 	$error = $li.find('div.error');

          // // 避免重复创建
          // if (!$error.length) {
          // 	$error = $('<div class="error"></div>').appendTo($li);
          // }

          // $error.text('上传失败');
        });

        // 完成上传完了，成功或者失败，先删除进度条。
        uploader.on("uploadComplete", function () {});
      });
    },

    /**
     * 初始化webuploader
     */
    // initUpload() {
    //   let token = localStorage.getItem("token");
    //   let that = this;
    //   var loading;
    //   let userId = localStorage.getItem("userId");
    //   var params = "userId=" + userId + "&token=" + token;
    //   // 初始化Web Uploader
    //   var uploader = WebUploader.create({
    //     // 选完文件后，是否自动上传。
    //     auto: true,

    //     method: "POST",

    //     // swf文件路径
    //     swf: "../utils/Uploader.swf",

    //     // 文件接收服务端。
    //     server: that.GLOBAL.BASE_URL + "v1/uploadImage?" + params,

    //     // 选择文件的按钮。可选。
    //     // 内部根据当前运行是创建，可能是input元素，也可能是flash.
    //     resize: false,
    //     pick: {
    //       id: "#filePicker",
    //       multiple: false,
    //     },

    //     // 可重复上传
    //     duplicate: true,

    //     // 只允许选择图片文件
    //     accept: {
    //       title: "Images",
    //       extensions: "gif,jpg,jpeg,bmp,png",
    //       mimeTypes: "image/*",
    //     },
    //     thumb: {
    //       width: 1,
    //       height: 1,

    //       // 图片质量，只有type为`image/jpeg`的时候才有效。
    //       quality: 90,

    //       // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
    //       allowMagnify: false,

    //       // 是否允许裁剪。
    //       crop: false,

    //       // 为空的话则保留原有图片格式。
    //       // 否则强制转换成指定的类型。
    //       // type: 'image/jpeg'
    //     },

    //     // 配置压缩的图片
    //     // compress:false,
    //     compress: {
    //       width: 750,
    //       height: 1334,

    //       // 图片质量，只有type为`image/jpeg`的时候才有效。
    //       quality: 70,

    //       // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
    //       allowMagnify: false,

    //       // 是否允许裁剪。
    //       crop: false,

    //       // 是否保留头部meta信息。
    //       preserveHeaders: true,

    //       // 如果发现压缩后文件大小比原来还大，则使用原来图片
    //       // 此属性可能会影响图片自动纠正功能
    //       noCompressIfLarger: false,

    //       // 单位字节，如果图片大小小于此值，不会采用压缩。
    //       compressSize: 0,
    //     },
    //   });
    //   // // 当有文件添加进来的时候
    //   // uploader.on('fileQueued', function(file) {
    //   // 	console.log(file)
    //   // 	// that.imageArr =

    //   // });
    //   //
    //   // 上传前触发
    //   // uploader.on("uploadStart", function(file) {

    //   // });

    //   // 在Web Uploader实例里添加onFileQueued事件
    //   // uploader.onFileQueued = function (file) {

    //   // 文件发送前，是否附加参数。
    //   uploader.on("uploadBeforeSend", function (obj, data) {
    //     data.hosId = hosItem.hosId;
    //     data.type = 1;
    //     data.wxId = localStorage.getItem("wxId");
    //     data.imageType = imageType;
    //     that.uploadState = true;
    //     console.log("uploadBeforeSend");
    //     loading = that.$weui.loading("上传中...", {
    //       className: "custom-classname",
    //     });
    //   });
    //   // // 文件上传过程中创建进度条实时显示。
    //   // uploader.on('uploadProgress', function(file, percentage) {
    //   // 	var $li = $('#' + file.id),
    //   // 		$percent = $li.find('.progress span');

    //   // 	// 避免重复创建
    //   // 	if (!$percent.length) {
    //   // 		$percent = $('<p class="progress"><span></span></p>')
    //   // 			.appendTo($li)
    //   // 			.find('span');
    //   // 	}

    //   // 	$percent.css('width', percentage * 100 + '%');
    //   // });

    //   // 文件上传成功，给item添加成功class, 用样式标记上传成功。
    //   uploader.on("uploadSuccess", function (file, response) {
    //     that.uploadState = false;
    //     console.log(response);
    //     loading.hide();
    //     if (response.result >= 2000) {
    //       Dialog({ message: response.msg });

    //       return;
    //     }
    //     uploader.makeThumb(
    //       file,
    //       function (error, src) {
    //         that.imageUrl = src;
    //         if (error) {
    //           // $img.replaceWith('<span>不能预览</span>');
    //           return;
    //         }
    //         var $imageId = "#image" + that.previewIndex;
    //         $($imageId).attr("src", src);
    //         $($imageId).addClass("wyfui-image");
    //         // var width = $($imageId).width();
    //         // var height = width * 0.8;
    //         // $($imageId).css('height', height);
    //       },
    //       1,
    //       1
    //     );
    //     vLibId = response.vLibId;
    //     that.createImageObj(that.previewIndex, response.files[0]);

    //     let name = response.name;
    //     let idNo = response.idNo;
    //     let CardFTip = response.msg;
    //     if (imageType == "ID_CARD_F") {
    //       that.name = name;
    //       that.cardId = idNo;
    //     } else {
    //       Notify({
    //         type: "warning",
    //         message: CardFTip,
    //       });
    //     }

    //   });
    //   // 文件上传失败，显示上传出错。
    //   uploader.on("uploadError", function (res) {
    //     console.log(res);
    //     that.uploadState = false;
    //     loading.hide();
    //     Notify({
    //       type: "warning",
    //       message: "上传失败,请稍后重试",
    //     });

    //     // var $li = $('#' + file.id),
    //     // 	$error = $li.find('div.error');

    //     // // 避免重复创建
    //     // if (!$error.length) {
    //     // 	$error = $('<div class="error"></div>').appendTo($li);
    //     // }

    //     // $error.text('上传失败');
    //   });

    //   // 完成上传完了，成功或者失败，先删除进度条。
    //   uploader.on("uploadComplete", function () {});
    // },
  },
};

function updateServicePathArr(index) {
  for (var i in servicePathArr) {
    var obj = servicePathArr[i];
    if (obj.requestImageIndex == index) {
      console.log("i = " + index);
      servicePathArr.splice(i, 1);
      return;
    }
  }
}

function checkServicePathArr(index, servicePathArr) {
  for (var i in servicePathArr) {
    var obj = servicePathArr[i];
    if (obj.requestImageIndex == index) {
      return true;
    }
  }
  return false;
}
</script>

<style>
.upload-page {
  background-color: #efeff4;
  overflow-x: hidden;
  margin-top: 80px;
}
.element-invisible {
  border: none;
}
.upload_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: #fff;
  text-align: center;
  -webkit-text-align: center;
  justify-content: center;
  /*子元素水平居中*/
  -webkit-justify-content: center;
  margin-top: 80px;
}

.upload_desc {
  font-size: 15px;
  color: #999;
  padding: 20px;
}

.upload_type {
  background: #efeff4;
  width: 100%;
  padding: 10px;
}

.upload_type_item {
  background: #fff;
  margin: 20px 50px;
  border: 1px solid #1aad19;
  border-radius: 5px;
  padding: 5px 0;
}

.type_item_c1 {
  font-size: 18px;
  color: #1aad19;
}

.type_item_c2 {
  font-size: 13px;
  color: #999;
}

.weui-label {
  display: flex;
  font-size: 15px;
}

.title-left {
  display: flex;
}

.type_name {
  width: 200px;
}

.weui-cell__bd {
  font-size: 15px;
}

.weui-cell__ft {
  font-size: 15px;
  color: #1aad19 !important;
}

.weui-cell_access .weui-cell__ft:after {
  color: #1aad19 !important;
}

.icon-select {
  margin-right: -6px;
}

.uploadtip {
  margin: 15px;
  position: relative;
}

.upload-tips {
  font-size: 15px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.wyf-ui {
  width: 100%;
  background: #fff;
  padding-top: 10px;
}

.wyfui-col-33 {
  width: 33.33336%;
  text-align: center;
  display: inline-block;
}

.wyfui-image {
  width: 86%;
  height: 90px;
  text-align: center;
}

.text-idcard {
  display: inline;
  color: red;
  font-size: 10px;
  line-height: 18px;
  white-space: nowrap;
}

.upload-input {
  margin-bottom: 80px;
}

.weui-gallery {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000;
  z-index: 1000;
}

.weui-gallery__img {
  top: 0;
  top: constant(safe-area-inset-top);
  top: env(safe-area-inset-top);
  bottom: 60px;
  bottom: calc(60px + constant(safe-area-inset-bottom));
  bottom: calc(60px + env(safe-area-inset-bottom));
  width: 100%;
  background: center center no-repeat;
  background-size: contain;
}

.weui-gallery__img,
.weui-gallery__opr {
  position: absolute;
  left: 0;
  left: constant(safe-area-inset-left);
  left: env(safe-area-inset-left);
  right: 0;
  right: constant(safe-area-inset-right);
  right: env(safe-area-inset-right);
}

.weui-gallery__opr {
  position: absolute;
  bottom: 0;
  padding-bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #0d0d0d;
  color: #fff;
  color: var(--weui-WHITE);
  line-height: 60px;
  text-align: center;
}

.weui-gallery__img,
.weui-gallery__opr {
  position: absolute;
  left: 0;
  left: constant(safe-area-inset-left);
  left: env(safe-area-inset-left);
  right: 0;
  right: constant(safe-area-inset-right);
  right: env(safe-area-inset-right);
}
.Sensitiveinformation {
  position: absolute;
  right: 0px;
  color: #1aac19;
}

/* 委托书事例css */
.powerOfAttorney {
  color: #1aac19;
}

/* .bookselifDiv .floatDiv {
  padding: 5%;

  height: 100%;
}

.notice-titles {
  margin-top: 50%;
  display: flex;
  display: -webkit-flex;
  text-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  z-index: 2007;
}
.bookselifDiv #noticeId {
  background: rgba(0, 0, 0, 0.8);
} */

.trustInstrumentImg {
  margin-top: 50%;
  display: flex;
  display: -webkit-flex;
  text-align: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.trustInstrumentDiv {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2007;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
